import * as Yup from "yup";
import {FIELD_NUMBER, FIELD_REQUIRED, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as nouveauPackageFormNames from "./nouveauPackageFormNames";

export const nouveauPackageValidationSchema = Yup.object().shape({
  [nouveauPackageFormNames.ROLE_OPERATEUR_FORM_NAME]: Yup.number()
    .typeError(FIELD_NUMBER)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.CRITERE_FACTURATION_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.PARAMETRE_DECOMPTE_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.TYPE_PAIEMENT_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.TRANSACTION_AUTORISEE_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.NOMBRE_TRANSACTIONS_FORM_NAME]: Yup.number()
    .typeError(FIELD_NUMBER)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.FRAIS_ACCES_ANNUEL_FORM_NAME]: Yup.number()
    .typeError(FIELD_NUMBER)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.DEBUT_VALIDITEE_PACKAGE_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.STATUS_PACKAGE_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.TYPE_FRAIS_SERVICE_PACKAGE_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [nouveauPackageFormNames.RECONDUCTION_PACKAGE_FORM_NAME]: Yup.bool()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),

  [nouveauPackageFormNames.FRAIS_TRANSACTION_FORM_NAME]: Yup.number()
    .typeError(FIELD_NUMBER)
    .nullable(true)
    .when(nouveauPackageFormNames.TYPE_FRAIS_SERVICE_PACKAGE_FORM_NAME, {
      is: (value) => {
        return value === "FIXE";
      },
      then: Yup.number().typeError(FIELD_NUMBER).required(FIELD_REQUIRED),
    }),

  [nouveauPackageFormNames.DESCRIPTION_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
});
